import { useTheme } from '@mui/material';
import { FC, memo, useEffect, useState } from 'react';
import { Polyline } from 'react-leaflet';
import { ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';

import { PositionEntity } from '../../../entities/PositionEntity';

type Props = {
  id: number;
  shipmentOrderLegRunEntityMap: Map<number, ShipmentOrderLegRunForPlanEntity>;
}

const OrderPolylinePresenter: FC<Props> = memo((
  {
    id,
    shipmentOrderLegRunEntityMap
  }
) => {
  const theme = useTheme();
  const data = shipmentOrderLegRunEntityMap.get(id);

  const [positions, setPositions] = useState<[PositionEntity, PositionEntity]>(undefined);

  useEffect(() => {
    if (!data) return;

    setPositions(
      [
        [data.loading_lat, data.loading_lng],
        [data.unloading_lat, data.unloading_lng]
      ]
    );
  }, [data]);

  if (!positions) return null;

  return (
    <Polyline
      pathOptions={{
        color: theme.colors.primary.main,
        weight: 5,
        opacity: 1
      }}
      positions={positions.map(([lat, lng]) => [Number(lat), Number(lng)])}
    />
  );
});

export default OrderPolylinePresenter;
